import { parse, stringify } from 'query-string';
import { getInstance } from '../player';
import { globals } from '../utils';
import { getParameterByName } from '../utils/getSkyfireEnvironment';
const LYRICS_VIEWED = [0];
const LYRICS_NOT_VIEWED = null;
export async function getSkyfireUrl(method, store) {
    const prefix = method.url.startsWith('/') ? globals.location.origin : '';
    const url = new URL(prefix + method.url);
    // preserve query string, if exists
    const searchParams = parse(url.search);
    if ((method.clientInformation || []).length > 0) {
        const player = await getInstance();
        method.clientInformation.forEach((clientInfo) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            if (clientInfo ===
                'Web.TemplatesInterface.v1_0.Touch.PlaylistTemplateInterface.PlaylistClientInformation') {
                const name = store.getState().Dialog.textInput;
                const playlistInfo = {
                    interface: clientInfo,
                    name,
                    path: globals.location.pathname,
                };
                Object.assign(searchParams, { playlistInfo: JSON.stringify(playlistInfo) });
            }
            if (clientInfo ===
                'Web.TemplatesInterface.v1_0.Touch.SettingsTemplateInterface.SendSmsOrEmailClientInformation') {
                const smsOrEmail = store.getState().Dialog.smsOrEmail;
                const smsOrEmailInfo = {
                    interface: clientInfo,
                    smsOrEmail,
                };
                Object.assign(searchParams, { smsOrEmailInfo: JSON.stringify(smsOrEmailInfo) });
            }
            if (clientInfo ===
                'Web.TemplatesInterface.v1_0.Touch.SearchTemplateInterface.SearchKeywordClientInformation') {
                const keyword = method.keyword || store.getState().SearchSuggestions.searchTerm.text || '';
                const searchKeyword = {
                    interface: clientInfo,
                    keyword,
                };
                Object.assign(searchParams, { keyword: JSON.stringify(searchKeyword) });
            }
            if (clientInfo === 'PageViewedMetricInterface.v1_0.LoadTimeClientInformation') {
                const loadTimeMilliseconds = window.sessionStorage.getItem(method.owner);
                if (loadTimeMilliseconds != null) {
                    const loadTimeClientInformation = {
                        interface: clientInfo,
                        loadTimeMilliseconds
                    };
                    Object.assign(searchParams, { loadTimeMilliseconds: JSON.stringify(loadTimeClientInformation) });
                }
            }
            if (clientInfo === 'PlaybackInterface.v1_0.MediaStateClientInformation') {
                const { mediaId } = store.getState().Media;
                const { startedAt, resumedAt, stalledAt } = player.getPlaybackTimestamps();
                const playbackState = ((_a = store.getState().PlaybackStates.play) === null || _a === void 0 ? void 0 : _a.state) || 'STOPPED';
                const mediaState = {
                    interface: clientInfo,
                    mediaPlayerName: 'MAESTRO',
                    playbackState,
                    playbackInitiationDelayMilliSeconds: 0,
                    streamFormat: (_c = (_b = player.metricsReporter) === null || _b === void 0 ? void 0 : _b.tracks[mediaId]) === null || _c === void 0 ? void 0 : _c.getMetricsStreamOrDRMTech(player),
                    bitrate: (_e = (_d = player.metricsReporter) === null || _d === void 0 ? void 0 : _d.tracks[mediaId]) === null || _e === void 0 ? void 0 : _e.getMetricsBitrates(player),
                    cacheHitStatus: (_g = (_f = player.metricsReporter) === null || _f === void 0 ? void 0 : _f.tracks[mediaId]) === null || _g === void 0 ? void 0 : _g.getMetricsCacheHitStatus(player),
                    rebufferCount: (_j = (_h = player.metricsReporter) === null || _h === void 0 ? void 0 : _h.tracks[mediaId]) === null || _j === void 0 ? void 0 : _j.rebufferCount,
                    cdnType: (_l = (_k = player.metricsReporter) === null || _k === void 0 ? void 0 : _k.tracks[mediaId]) === null || _l === void 0 ? void 0 : _l.cdnType,
                    playbackStartedAtTimeStampMilliSeconds: startedAt,
                    // playbackResumedAtTimeStampMilliSeconds: resumedAt,
                    progressInMilliSeconds: Math.round(player.getCurrentTime() * 1000),
                    transferBytesPerSecond: '' + player.getLatestBandwidthBPS(),
                };
                if (stalledAt) {
                    mediaState.rebufferDurationMilliSeconds = Date.now() - stalledAt;
                    mediaState.playbackInterruptionMilliSeconds = Date.now() - stalledAt; // Same as rebufferDurationMilliSeconds
                }
                Object.assign(searchParams, { mediaState: JSON.stringify(mediaState) });
            }
            if (clientInfo === 'PlaybackInterface.v1_0.LyricLinesClientInformation') {
                const lyricsViewed = store.getState().LyricsViewed.lyricsViewed;
                const lyricsInfo = {
                    interface: clientInfo,
                    viewedLines: lyricsViewed === true ? LYRICS_VIEWED : LYRICS_NOT_VIEWED,
                };
                Object.assign(searchParams, { lines: JSON.stringify(lyricsInfo) });
            }
            if (clientInfo === 'PlaybackInterface.v1_0.PlaybackErrorClientInformation') {
                const error = player.getLatestError();
                const errorInfo = {
                    interface: clientInfo,
                    message: error.error
                };
                Object.assign(searchParams, { error: JSON.stringify(errorInfo) });
            }
            if (clientInfo === 'Web.TemplatesInterface.v1_0.Touch.DialogTemplateInterface.LanguageSettingClientInformation') {
                const { displayLanguageId } = store.getState().Authentication;
                const languageInfo = {
                    interface: clientInfo,
                    languageId: displayLanguageId
                };
                Object.assign(searchParams, { displayLanguage: JSON.stringify(languageInfo) });
            }
            if (clientInfo === 'PlaybackInterface.v1_0.VolumeClientInformation') {
                const volumeInfo = {
                    interface: clientInfo,
                    volume: player.getVolume()
                };
                Object.assign(searchParams, { volume: JSON.stringify(volumeInfo) });
            }
            if (clientInfo === 'PageViewedMetricInterface.v1_0.RefMarkerClientInformation') {
                const refMarker = getParameterByName('ref', globals.location.href) ||
                    getParameterByName('_ref', globals.location.href) ||
                    getParameterByName('refMarker', globals.location.href) || '';
                const refMarkerInfo = {
                    interface: clientInfo,
                    refMarker,
                };
                Object.assign(searchParams, { refMarker: JSON.stringify(refMarkerInfo) });
            }
            if (clientInfo === 'Web.PageInterface.v1_0.SelectedItemsClientInformation') {
                const items = [];
                const multiSelect = store.getState().Storage.MULTISELECT || {};
                const keys = Object.keys(multiSelect).filter((k) => !k.startsWith('_'));
                for (const key of keys) {
                    // @ts-ignore
                    items.push(multiSelect[key]);
                }
                const selectedItemInfo = {
                    interface: clientInfo,
                    ids: items,
                };
                Object.assign(searchParams, { selectedIds: JSON.stringify(selectedItemInfo) });
            }
            if (clientInfo === 'Web.PageInterface.v1_0.DownloadSelectedItemsClientInformation') {
                const items = [];
                const downloadSelect = store.getState().Storage.DOWNLOAD_SELECT || {};
                const keys = Object.keys(downloadSelect).filter((k) => !k.startsWith('_'));
                for (const key of keys) {
                    // @ts-ignore
                    items.push(downloadSelect[key]);
                }
                const downloadSelectedItemInfo = {
                    interface: clientInfo,
                    ids: items,
                };
                Object.assign(searchParams, { downloadSelectedIds: JSON.stringify(downloadSelectedItemInfo) });
            }
            if (clientInfo === 'PlaybackInterface.v1_0.ScrubClientInformation') {
                const scrubInfo = store.getState().ScrubInfo;
                const scrubClientInfo = {
                    interface: clientInfo,
                    currentTime: scrubInfo.currentTime,
                    scrubTime: scrubInfo.scrubTime,
                };
                Object.assign(searchParams, { scrub: JSON.stringify(scrubClientInfo) });
            }
            if (clientInfo === "Web.TemplatesInterface.v1_0.Touch.PlaylistTemplateInterface.MoveTrackInPlaylistClientInformation" ||
                clientInfo === "PlaybackInterface.v1_0.MoveQueueEntitiesClientInformation") {
                if (sessionStorage.getItem('dropIndex') && sessionStorage.getItem('moveTrackIndex')) {
                    const moveTrackClientInformation = {
                        interface: clientInfo,
                        // @ts-ignore
                        dropIndex: +sessionStorage.getItem('dropIndex'),
                        // @ts-ignore: 
                        entryIndex: +sessionStorage.getItem('moveTrackIndex')
                    };
                    Object.assign(searchParams, { reorder: JSON.stringify(moveTrackClientInformation) });
                }
            }
        });
    }
    // get base url. Even if there is no ? split will return single element, so its safe and browser agnostic
    const baseUrl = url.href.split('?')[0]
        .replace('https://dev-na.mobile.music.a2z.com', '')
        .replace('http://localhost:8080/tvmusic', '');
    // assemble query string, skip empty and null
    const query = stringify(searchParams, { skipEmptyString: true, skipNull: true });
    return baseUrl + (query.length === 0 ? '' : `?${query}`);
}
